import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { BLUEPRINT_DETAILS_CACHE_KEY } from 'services/queryKeys';
import { Blueprint, BlueprintFromApi } from 'types';

type UseGetBlueprintDetailsProps = {
  blueprintId: string | number;
  enabled?: boolean;
};

export const useGetBlueprintDetails = ({ blueprintId, enabled = true }: UseGetBlueprintDetailsProps) => {
  const {
    data: blueprintDetailsFromApi,
    isLoading,
    isError,
    error,
    refetch,
  } = useAxiosQuery<BlueprintFromApi>(BLUEPRINT_DETAILS_CACHE_KEY(blueprintId), `/blueprints/${blueprintId}/`, {
    enabled: enabled && !!blueprintId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  // Data is already transformed by useAxiosQuery (keysToCamelCase)
  const blueprintDetails: Blueprint | undefined = blueprintDetailsFromApi as Blueprint | undefined;

  return {
    blueprintDetails,
    isLoading,
    isError,
    error,
    refetch,
  };
};
